<template>
  <div class="kpt-detail-content has-background-white-ter p-4">
    <div class="columns">
      <div class="column is-one-half">
        <div class="card" v-if="user">
          <header class="card-header">
            <p class="card-header-title">User Information</p>
          </header>
          <div class="card-content">
            <detail-field label-width="175">
              <template v-slot:label>Name</template>
              <template v-slot:value>{{user.firstName + ' ' + user.lastName}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Email</template>
              <template v-slot:value>{{user.email}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Role</template>
              <template v-slot:value>{{user.roleName}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Login Type</template>
              <template v-slot:value>{{user.loginType}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Last Login</template>
              <template v-slot:value>{{user.lastLogin}}</template>
            </detail-field>
          </div>
        </div>
      </div>
      <div class="column is-one-half">
        <div class="card" v-if="userAccount">
          <header class="card-header">
            <p class="card-header-title">Account Information</p>
          </header>
          <div class="card-content">
            <detail-field label-width="175">
              <template v-slot:label>Name</template>
              <template v-slot:value>{{userAccount.name}}</template>
            </detail-field>
            <detail-field label-width="175" v-if="$hasRole('Super User,Kymeta Admin,Sales Support')">
              <template v-slot:label>OSS Id</template>
              <template v-slot:value>{{ userAccount.id }}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Type</template>
              <template v-slot:value>{{userAccount.relationshipType}}</template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Pricebooks</template>
              <template v-slot:value>
                  <span v-if="userAccount.configurator?.commercialPriceBook">Commercial &nbsp;</span>
                  <span v-if="userAccount.configurator?.militaryPriceBook">Military</span>
              </template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Pricing</template>
              <template v-slot:value>
                  <span v-if="userAccount.configurator?.wholesalePricesVisible">Wholesale</span>
                  <span v-if="userAccount.configurator?.msrpPricesVisibl3">MSRP</span>
              </template>
            </detail-field>
            <detail-field label-width="175">
              <template v-slot:label>Discount Tier</template>
              <template v-slot:value>{{userAccount.configurator?.discountTier}}</template>
            </detail-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <header class="card-header">
          <p class="card-header-title">Visible Accounts</p>
      </header>
      <div class="card-content">
        <div class="py-2">
          <b-input placeholder="Filter by name..." v-model="accountFilter" style="width: 250px" />
        </div>
        <b-table 
        :data="filteredAccounts" 
        paginated
        per-page="15"
        :current-page.sync="currentPage"
        default-sort-direction="desc"
        default-sort="releaseDate"
        :striped="true">
          <b-table-column field="name" label="Name" v-slot="props">
              <a @click.prevent="selectAccount(props.row.id)">{{ props.row.name }}</a>
          </b-table-column>

          <b-table-column field="relationshipType" label="Account Type" v-slot="props" width="250" sortable>
              {{ props.row.relationshipType }}
          </b-table-column>

          <b-table-column field="parent.name" label="Parent Account" v-slot="props" width="250" sortable>
              {{ props.row.parent?.name }}
          </b-table-column>
        </b-table>
      </div>
    </div>
    
    <b-sidebar
      class="sidebar-inner"
      :fullheight="true"
      :fullwidth="false"
      :overlay="false"
      :right="true"
      :open="selectedAccount != null"
      @close="selectedAccount = null"
      position="absolute"
      :can-cancel="['escape']"
    >
      <account-detail-component @reselect="selectAccount" @close="selectAccount(null)" :selectedAccount="selectedAccount" :shared-accounts="sharedAccounts"></account-detail-component>
    </b-sidebar>
  </div>
</template>
<script>
import { orderBy } from 'lodash';
import AccountDetailComponent from './components/AccountDetailComponent.vue';

export default {
  data() {
    return {
      accountFilter: '',
      sharedAccounts: [],
      currentPage: 1
    }
  },
  components: {
    AccountDetailComponent
  },
  methods: {
    selectAccount(id) {
      this.$store.commit('fetchAccount', id);
    },
    async fetchSharedAccounts(selectedAccountId) {
      if (!selectedAccountId) return;
      this.sharedAccounts = [];
      const res = await fetch(`/v2/accounts/sharedWith?id=${selectedAccountId}`);
      if (!res.ok) return;
      const data = await res.json();
      data.forEach(a => this.sharedAccounts.push(a));
    }
  },
  computed: {
    allAccounts() {
      return orderBy(this.$store.state.accounts.accounts, ['name'], ['asc']);
    },
    filteredAccounts() {
      if (!this.accountFilter) return this.allAccounts;
      const filterString = this.accountFilter?.trim().toLowerCase();
      return this.allAccounts.filter(a => a.name?.toLowerCase().includes(filterString));
    },
    selectedAccount() {
      // get selectedAccount's sharedWithAccount list
      this.fetchSharedAccounts(this.$store.state.accounts.selectedAccount?.id);
      return this.$store.state.accounts.selectedAccount;
    },
    user() {
      return this.$store.getters.user;
    },
    userAccount() {
      return this.allAccounts.find(a => a.id == this.user.accountId);
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/mixins';
@import '../styles/colors';

.kpt-detail-content {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  flex: 1 1 auto;
  position: relative;
}

.kpt-accounts-grid {
  @include display-grid;
  grid-template-columns: 350px auto;
  gap: 12px;
  flex: 1 1 auto;
  height: calc(100vh - 220px);

  .kpt-accounts-grid-tree {
    height: 100%;
    overflow-y: auto;
    padding-right: 12px;
  }

  .kpt-account-detail {
    border-left: 1px solid $grey-lighter;
    padding: 0 12px;
    height: 100%;
    overflow-y:auto;
  }

  .b-table {
    max-width: 350px;
  }

  .column-left-padding-0 {
    padding-left: 0px;
  }
}
</style>
